import LangSelect from "@/components/langSelect";
import TitleBaseBox from "@/views/zhiji/bComponents/TitleBaseBox";

export default {
    name: "StatementTypeCreatePane",
    props: ["data"],
    components: {
        LangSelect,
        TitleBaseBox
    },
    data() {
        return {
            typeLanguage: this.data.language,
            typeName: this.data.typeName
        };
    },
    computed: {
        confirmLabel() {
            return this.$t("zhiji.common.confirm");
        },
        cancelLabel() {
            return this.$t("zhiji.common.cancel");
        }
    },
    methods: {
        cancelClick() {
            this.close();
        },
        confirmClick() {
            const params = { language: this.typeLanguage, type_name: this.typeName };
            this.$store.dispatch("statement/addStmtType", params);
            this.close();
        },
        close() {
            this.$emit("closeModal");
        }
    }
};
